import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableCauserieCreatePage = withAsyncLoading(async () =>
    import('./CauserieCreatePage').then((res) => res.CauserieCreatePage)
);

export { LoadableCauserieCreatePage };
